import { z } from 'zod'

import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

import { ConversationEndReason } from './types'

export const LeadQualPlaygroundSocketEventsSchemas = {
  messageGenerated: SocketEventBaseSchema.extend({
    event: z.literal('ai_automation_message_generated'),
    session_id: z.string(),
    message_event_id: z.string().nullable().optional(),
    message: z.object({
      text: z.string(),
    }),
  }),

  goalFinished: SocketEventBaseSchema.extend({
    event: z.literal('ai_engagement_goal_finished'),
    session_id: z.string(),
    reason: z.union([
      z.literal(ConversationEndReason.ACHIEVED),
      z.literal(ConversationEndReason.OPERATOR_REQUESTED),
    ]),
  }),

  fieldObtained: SocketEventBaseSchema.extend({
    event: z.literal('ai_automation_field_obtained'),
    session_id: z.string(),
    field_id: z.string(),
    field_value: z.union([z.number(), z.string(), z.boolean()]),
  }),
}
